import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { nsSharedStyles } from '../ns-styles/index.js';

import './ns-input-field.js';

export interface RegistrarRecordField {
  label: string;
  value?: string | number | null;
}

@customElement('ns-registrar-record')
export class NSRegistrarRecord extends LitElement {
  @property({ type: String })
  heading = '';

  @property({ type: String })
  intro = '';

  @property({ attribute: false })
  fields: RegistrarRecordField[] = [];

  static styles = [
    nsSharedStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;
      }

      .heading {
        display: flex;
        align-items: center;
        margin-bottom: var(--wa-space-2xs);
      }

      .heading strong {
        flex: 1;
        font-size: var(--wa-font-size-m);
      }

      .intro {
        margin-bottom: var(--wa-space-m);
      }

      .field {
        display: flex;
        flex-direction: column;
        margin-bottom: var(--wa-space-xs);
      }
    `,
  ];

  render() {
    return html`
      <div class="heading">
        <strong>${this.heading}</strong>
        <slot name="status"></slot>
      </div>
      <div class="intro small">${this.intro}</div>
      ${this.fields.map(
        (field) => html`
          <div class="field">
            <ns-input-field disabled value=${field.value ?? ''} label=${field.label}></ns-input-field>
          </div>
        `,
      )}
      <slot></slot>
    `;
  }
}
